module.exports = __webpack_public_path__ + "img/imlca-logo.43922237.png";